import VanillaCalendar from '@uvarov.frontend/vanilla-calendar'

import '@uvarov.frontend/vanilla-calendar/build/vanilla-calendar.min.css'
// import '@uvarov.frontend/vanilla-calendar/build/themes/dark.min.css'

export default class Calendar {
  constructor(selected) {
    const options = {
      DOMTemplates: {
        default: `
          <div class="vanilla-calendar-header">
            <div class="vanilla-calendar-header__content">
              <#Month /><#Year />
            </div>
            <#ArrowPrev />
            <#ArrowNext />
            <#Week />
          </div>
          <div class="vanilla-calendar-wrapper">
            <div class="vanilla-calendar-content">
              <#Days />
            </div>
          </div>`,
        year: `
          <div class="vanilla-calendar-header">
            <div class="vanilla-calendar-header__content">
              <#Month />
              <#Year />
            </div>
            <#ArrowPrev />
            <#ArrowNext />
          </div>
          <div class="vanilla-calendar-wrapper">
            <div class="vanilla-calendar-content">
              <#Years />
            </div>
          </div>`,
      },
      input: true,
      actions: {
        changeToInput: () => {
          this.updateState()
        },
      },
      settings: {
        lang: 'ro',
        selected: {
          dates: selected,
        },
        range: {
          disableAllDays: true,
        },
      },
    }

    this.container = document.querySelector('#calendar-component')
    if (!this.container) return

    this.input = this.container.querySelector('input')
    this.trigger = this.container.querySelector('.dropdown-trigger .button')
    this.clearBtn = this.container.querySelector('.dropdown-clear')
    // this.label = this.trigger.querySelector('.js-label')

    if (selected) {
      this.container.classList.add('is-set')
      this.clearBtn.classList.remove('is-hidden')
    }

    this.instance = new VanillaCalendar(this.trigger, options)
    this.instance.init()

    this.clearBtn.addEventListener('click', () => {
      this.instance.settings.selected.dates = []
      this.instance.reset()
      this.updateState()
    })
  }

  updateState() {
    const dates = this.instance.selectedDates

    if (dates[0]) {
      // this.label.innerHTML = dates[0]
      this.input.value = dates[0]
      this.container.classList.add('is-set')
      this.instance.HTMLElement.classList.add('vanilla-calendar_hidden')
    } else {
      this.input.value = ''
      this.container.classList.remove('is-set')
      // this.label.innerHTML = 'Calendar'
    }

    this.clearBtn.classList.toggle('is-hidden', !dates[0])

    if (this.onUpdate) this.onUpdate.call()
  }

  setEventsDays(days) {
    this.instance.settings.range.enabled = days
    // this.instance.settings.selected.holidays = days
    this.instance.update()
  }
}
